import React from 'react';

const About = () => {
  return (
    <section className='section about-section'>
      <h1 classname='section-title'>About Us</h1>
      <p>
        “Give the user a way to search easily, an intuitive interface
        interaction, and watch the magic happen ” -Ashley Christensen,
        Co-Founder, CocktailsDB
      </p>
    </section>
  );
};

export default About;
